import { getSession } from 'shared/lib/auth/actions';
import { isAccessTokenExpired } from 'shared/lib/utils/isAccessTokenExpired';
import { cachedPostRefresh } from 'shared/lib/auth/cachedRefresh';

// const cachedFetchRefresh = async () => {
//   return await fetch(`${process.env.NEXT_PUBLIC_URL}/api/login/refresh`, {
//     method: 'GET',
//     credentials: 'include',
//     cache: 'no-store',
//   });
// };

export const getAccessToken = async (): Promise<string | undefined> => {
  const session = await getSession();

  // @ts-ignore
  // console.log('is token expired? ', isAccessTokenExpired(session.expires_at));
  // console.log('expires at: ', session?.expires_at);

  if (session?.expires_at && isAccessTokenExpired(session.expires_at)) {
    // console.log('expired, now refreshing from sessionTokenAccessor');

    // const response = await cachedFetchRefresh();

    // const response = await fetch(
    //   `${process.env.NEXT_PUBLIC_URL}/api/login/refresh`,
    //   {
    //     method: 'POST',
    //     // credentials: 'include',
    //     cache: 'force-cache',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(session),
    //   }
    // );
    //
    // if (!response.ok) {
    //   console.log('error refreshing token');
    // }
    //
    // const updatedSession = await response.json();
    const updatedSession = await cachedPostRefresh(session);
    return updatedSession;
    // console.log('access token refreshed and saved to cookie: ', updatedSession);

    // setCookie('session', updatedSession, {
    //   httpOnly: true,
    //   secure: process.env.NODE_ENV === 'production',
    //   sameSite: 'lax',
    //   path: '/',
    //   expires: updatedSession.refresh_expires_in,
    // });

    // await createSession(updatedSession);
    // return updatedSession.user.access_token;
    // }

    // console.log(
    //   'Error refreshing access token in server component',
    //   response.status
    // );
    // const updatedSession = await updateSession(session);
    // await saveUserTokens(updatedSession);
  }
  //
  // console.log(
  //   'passing down session after not refreshing: ',
  //   session?.expires_at
  // );
  return session?.user.access_token;
};
